import { memo } from "react";

/**
 * The full-colour Novi lattice mark, paired with the wordmark in the About modal.
 *
 * Ported verbatim from novi-apps' `@novi/design` `LogoNoviMark`. The gradient is
 * the brand's and reads on both themes, so it does not follow `currentColor`.
 */
function IconNoviMark({ size = 24, className = undefined }) {
  return (
    <svg
      height={size}
      width={size}
      viewBox="0 0 152 152"
      fill="none"
      className={className}
      role="img"
      aria-label="Novi"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M146.512 34.8393C146.256 34.4791 145.938 34.1569 145.544 33.9294L100.026 7.6775C99.0771 7.13256 97.8485 7.13256 96.895 7.6775C95.9274 8.23666 95.3297 9.27442 95.3297 10.388V57.4709L54.5073 33.9294C53.5586 33.3845 52.3301 33.3845 51.3766 33.9294L5.86297 60.1814C4.8953 60.7358 4.29288 61.7783 4.29288 62.8919V115.396C4.29288 115.677 4.32924 115.95 4.40198 116.216C4.61543 117.002 5.13722 117.689 5.85823 118.102L5.86297 118.106L51.3719 144.353C51.8462 144.633 52.3917 144.78 52.942 144.78C53.497 144.78 54.0377 144.633 54.5073 144.363C55.475 143.804 56.0774 142.766 56.0774 141.652V94.5648L96.8903 118.102C96.8935 118.105 96.895 118.106 96.895 118.106L142.409 144.353C142.883 144.633 143.424 144.78 143.979 144.78C144.529 144.78 145.075 144.633 145.544 144.363C146.512 143.804 147.11 142.766 147.11 141.652V89.1438V36.6399C147.11 35.9813 146.882 35.3605 146.512 34.8393ZM95.3297 68.3176V109.975L59.2129 89.1438L95.3297 68.3176ZM56.0774 83.7276V42.0657L92.1943 62.8966L56.0774 83.7276ZM101.596 68.3223L137.713 89.1485L101.596 109.98V68.3223ZM49.8113 83.7276L13.6945 62.9014L49.8113 42.0704V83.7276ZM10.559 68.3223L46.6759 89.1533L10.559 109.98V68.3223ZM140.843 83.7323L104.727 62.9014L140.843 42.0751V83.7323ZM101.596 57.4756V15.8184L137.713 36.6494L131.247 40.3787L101.596 57.4756ZM13.6945 115.4L49.8113 94.5743V136.231L13.6945 115.4ZM104.727 115.4L140.843 94.5695V136.231L104.727 115.4Z"
        fill="url(#paint0_linear_noviMark)"
      />
      <path
        d="M8.01648 55.765C3.59556 55.765 0 59.3616 0 63.778C0 68.1944 3.59556 71.791 8.01648 71.791C12.4421 71.791 16.0377 68.1944 16.0377 63.778C16.0377 59.3616 12.4421 55.765 8.01648 55.765Z"
        fill="url(#paint1_linear_noviMark)"
      />
      <path
        d="M52.9419 81.1309C48.521 81.1309 44.9254 84.7275 44.9254 89.1439C44.9254 93.5603 48.521 97.1569 52.9419 97.1569C57.3676 97.1569 60.9679 93.5603 60.9679 89.1439C60.9679 84.7275 57.3676 81.1309 52.9419 81.1309Z"
        fill="url(#paint2_linear_noviMark)"
      />
      <path
        d="M98.4604 54.8789C94.0394 54.8789 90.4391 58.4755 90.4391 62.8919C90.4391 67.3083 94.0394 70.9049 98.4604 70.9049C102.881 70.9049 106.482 67.3083 106.482 62.8919C106.482 58.4755 102.881 54.8789 98.4604 54.8789Z"
        fill="url(#paint3_linear_noviMark)"
      />
      <path
        d="M98.4604 107.388C94.0394 107.388 90.4391 110.979 90.4391 115.396C90.4391 119.817 94.0394 123.409 98.4604 123.409C102.881 123.409 106.482 119.817 106.482 115.396C106.482 110.979 102.881 107.388 98.4604 107.388Z"
        fill="url(#paint4_linear_noviMark)"
      />
      <path
        d="M52.9419 28.6317C48.521 28.6317 44.9254 32.2236 44.9254 36.64C44.9254 41.0611 48.521 44.653 52.9419 44.653C57.3676 44.653 60.9679 41.0611 60.9679 36.64C60.9679 32.2236 57.3676 28.6317 52.9419 28.6317Z"
        fill="url(#paint5_linear_noviMark)"
      />
      <path
        d="M143.979 81.1309C139.553 81.1309 135.958 84.7275 135.958 89.1439C135.958 93.5603 139.553 97.1569 143.979 97.1569C148.4 97.1569 152 93.5603 152 89.1439C152 84.7275 148.4 81.1309 143.979 81.1309Z"
        fill="url(#paint6_linear_noviMark)"
      />
      <path
        d="M8.01648 107.388C3.59556 107.388 0 110.979 0 115.396C0 119.817 3.59556 123.409 8.01648 123.409C12.4421 123.409 16.0377 119.817 16.0377 115.396C16.0377 110.979 12.4421 107.388 8.01648 107.388Z"
        fill="url(#paint7_linear_noviMark)"
      />
      <path
        d="M52.9419 133.639C48.521 133.639 44.9254 137.231 44.9254 141.652C44.9254 146.069 48.521 149.661 52.9419 149.661C57.3676 149.661 60.9679 146.069 60.9679 141.652C60.9679 137.231 57.3676 133.639 52.9419 133.639Z"
        fill="url(#paint8_linear_noviMark)"
      />
      <path
        d="M143.979 44.653C148.4 44.653 152 41.0611 152 36.64C152 32.2236 148.4 28.6317 143.979 28.6317C139.553 28.6317 135.958 32.2236 135.958 36.64C135.958 41.0611 139.553 44.653 143.979 44.653Z"
        fill="url(#paint9_linear_noviMark)"
      />
      <path
        d="M98.4604 2.375C94.0394 2.375 90.4391 5.97161 90.4391 10.388C90.4391 14.8044 94.0394 18.401 98.4604 18.401C102.881 18.401 106.482 14.8044 106.482 10.388C106.482 5.97161 102.881 2.375 98.4604 2.375Z"
        fill="url(#paint10_linear_noviMark)"
      />
      <path
        d="M143.979 133.639C139.553 133.639 135.958 137.231 135.958 141.652C135.958 146.069 139.553 149.661 143.979 149.661C148.4 149.661 152 146.069 152 141.652C152 137.231 148.4 133.639 143.979 133.639Z"
        fill="url(#paint11_linear_noviMark)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_noviMark"
          x1="-49.547"
          y1="40.001"
          x2="114.943"
          y2="-51.5841"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#506CB3" />
          <stop offset="0.25" stopColor="#679AA6" />
          <stop offset="0.5" stopColor="#7FC89A" />
          <stop offset="0.593" stopColor="#BEC655" />
          <stop offset="0.694" stopColor="#FEC510" />
          <stop offset="0.798" stopColor="#F57E1B" />
          <stop offset="0.923" stopColor="#ED3726" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_noviMark"
          x1="-27.4828"
          y1="71.0371"
          x2="163.792"
          y2="-35.4616"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#506CB3" />
          <stop offset="0.25" stopColor="#679AA6" />
          <stop offset="0.5" stopColor="#7FC89A" />
          <stop offset="0.593" stopColor="#BEC655" />
          <stop offset="0.694" stopColor="#FEC510" />
          <stop offset="0.798" stopColor="#F57E1B" />
          <stop offset="0.923" stopColor="#ED3726" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_noviMark"
          x1="-14.5559"
          y1="114.183"
          x2="176.719"
          y2="7.68457"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#506CB3" />
          <stop offset="0.25" stopColor="#679AA6" />
          <stop offset="0.5" stopColor="#7FC89A" />
          <stop offset="0.593" stopColor="#BEC655" />
          <stop offset="0.694" stopColor="#FEC510" />
          <stop offset="0.798" stopColor="#F57E1B" />
          <stop offset="0.923" stopColor="#ED3726" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_noviMark"
          x1="-31.5095"
          y1="122.642"
          x2="159.765"
          y2="16.1428"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#506CB3" />
          <stop offset="0.25" stopColor="#679AA6" />
          <stop offset="0.5" stopColor="#7FC89A" />
          <stop offset="0.593" stopColor="#BEC655" />
          <stop offset="0.694" stopColor="#FEC510" />
          <stop offset="0.798" stopColor="#F57E1B" />
          <stop offset="0.923" stopColor="#ED3726" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_noviMark"
          x1="-1.1394"
          y1="158.272"
          x2="190.135"
          y2="51.7735"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#506CB3" />
          <stop offset="0.25" stopColor="#679AA6" />
          <stop offset="0.5" stopColor="#7FC89A" />
          <stop offset="0.593" stopColor="#BEC655" />
          <stop offset="0.694" stopColor="#FEC510" />
          <stop offset="0.798" stopColor="#F57E1B" />
          <stop offset="0.923" stopColor="#ED3726" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_noviMark"
          x1="-44.925"
          y1="78.554"
          x2="146.35"
          y2="-27.9446"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#506CB3" />
          <stop offset="0.25" stopColor="#679AA6" />
          <stop offset="0.5" stopColor="#7FC89A" />
          <stop offset="0.593" stopColor="#BEC655" />
          <stop offset="0.694" stopColor="#FEC510" />
          <stop offset="0.798" stopColor="#F57E1B" />
          <stop offset="0.923" stopColor="#ED3726" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_noviMark"
          x1="-18.0931"
          y1="166.73"
          x2="173.182"
          y2="60.2315"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#506CB3" />
          <stop offset="0.25" stopColor="#679AA6" />
          <stop offset="0.5" stopColor="#7FC89A" />
          <stop offset="0.593" stopColor="#BEC655" />
          <stop offset="0.694" stopColor="#FEC510" />
          <stop offset="0.798" stopColor="#F57E1B" />
          <stop offset="0.923" stopColor="#ED3726" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_noviMark"
          x1="2.37458"
          y1="106.066"
          x2="193.649"
          y2="-0.43277"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#506CB3" />
          <stop offset="0.25" stopColor="#679AA6" />
          <stop offset="0.5" stopColor="#7FC89A" />
          <stop offset="0.593" stopColor="#BEC655" />
          <stop offset="0.694" stopColor="#FEC510" />
          <stop offset="0.798" stopColor="#F57E1B" />
          <stop offset="0.923" stopColor="#ED3726" />
        </linearGradient>
        <linearGradient
          id="paint8_linear_noviMark"
          x1="15.8138"
          y1="149.814"
          x2="207.089"
          y2="43.3151"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#506CB3" />
          <stop offset="0.25" stopColor="#679AA6" />
          <stop offset="0.5" stopColor="#7FC89A" />
          <stop offset="0.593" stopColor="#BEC655" />
          <stop offset="0.694" stopColor="#FEC510" />
          <stop offset="0.798" stopColor="#F57E1B" />
          <stop offset="0.923" stopColor="#ED3726" />
        </linearGradient>
        <linearGradient
          id="paint9_linear_noviMark"
          x1="-48.4618"
          y1="131.101"
          x2="142.813"
          y2="24.6023"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#506CB3" />
          <stop offset="0.25" stopColor="#679AA6" />
          <stop offset="0.5" stopColor="#7FC89A" />
          <stop offset="0.593" stopColor="#BEC655" />
          <stop offset="0.694" stopColor="#FEC510" />
          <stop offset="0.798" stopColor="#F57E1B" />
          <stop offset="0.923" stopColor="#ED3726" />
        </linearGradient>
        <linearGradient
          id="paint10_linear_noviMark"
          x1="-61.8782"
          y1="87.0124"
          x2="129.397"
          y2="-19.4863"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#506CB3" />
          <stop offset="0.25" stopColor="#679AA6" />
          <stop offset="0.5" stopColor="#7FC89A" />
          <stop offset="0.593" stopColor="#BEC655" />
          <stop offset="0.694" stopColor="#FEC510" />
          <stop offset="0.798" stopColor="#F57E1B" />
          <stop offset="0.923" stopColor="#ED3726" />
        </linearGradient>
        <linearGradient
          id="paint11_linear_noviMark"
          x1="12.277"
          y1="202.361"
          x2="203.552"
          y2="95.862"
          gradientUnits="userSpaceOnUse">
          <stop stopColor="#506CB3" />
          <stop offset="0.25" stopColor="#679AA6" />
          <stop offset="0.5" stopColor="#7FC89A" />
          <stop offset="0.593" stopColor="#BEC655" />
          <stop offset="0.694" stopColor="#FEC510" />
          <stop offset="0.798" stopColor="#F57E1B" />
          <stop offset="0.923" stopColor="#ED3726" />
        </linearGradient>
      </defs>
    </svg>
  );
}

export default memo(IconNoviMark);
